import { useCallback, useEffect, useState } from 'react';
import { TOption } from '@src/types';
import { getProductOptions, ProductQueries } from '@src/services/products.ts';

export const useProductOptions = (params?: ProductQueries) => {
  const [productOptions, setProductOptions] = useState<TOption[]>([]);

  const fetchProductOptions = useCallback(async () => {
    const res = await getProductOptions(params);
    const options = res.data.map((item) => ({
      label: item.title,
      value: String(item.id),
    }));

    setProductOptions(options as TOption[]);
  }, [JSON.stringify(params)]);

  useEffect(() => {
    fetchProductOptions().then();
  }, [fetchProductOptions]);

  return { productOptions, refresh: fetchProductOptions };
};
